import React, { useLayoutEffect, useState, useEffect, useRef } from "react"
import classNames from "classnames"
import styles from "./Skills.module.scss"
import TagEditor from "../../../TagEditor/TagEditor"
import Button from "../../../Button/Button"
import ProfileTableItem from "../../ProfileTableItem"
import { Prompt } from "react-router"
import { objectComparison } from "../../../../helpers"
import ConfirmCancelPopup from "../../../Popup/ConfirmCancelPopup"
import { messages } from "../../../../helpers/constants"

const Skills = ({ data, update, anotherUser }) => {
  const [skillsData, setSkillsData] = useState([])
  const [editingSkillsData, setEditingSkillsData] = useState([])
  const [editing, isEditing] = useState(false)
  const [popupVisible, isPopupVisible] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)
  const [isClamped, setIsClamped] = useState(false)
  const skillsRef = useRef(null)

  useEffect(() => {
    if (data) {
      setSkillsData(data)
      setEditingSkillsData(data)
    }
  }, [data])

  useEffect(() => {
    setIsExpanded(false)
  }, [skillsData])

  useLayoutEffect(() => {
    if (!skillsData?.length || isExpanded) return
    const el = skillsRef.current
    if (!el) return
    const isOverflowing = el.scrollHeight > el.clientHeight + 1
    setIsClamped(isOverflowing)
  }, [skillsData, isExpanded])

  const handleCancel = () => {
    setEditingSkillsData(skillsData)
    isEditing(false)
    isPopupVisible(false)
  }
  const handleSave = () => {
    update({ skills: editingSkillsData })
    setSkillsData(editingSkillsData)
    isEditing(false)
  }
  return (
    <div className={styles.skillsWrap}>
      {popupVisible && (
        <ConfirmCancelPopup
          handleCancel={handleCancel}
          setIsPopupOpened={isPopupVisible}
        />
      )}
      <Prompt
        when={!objectComparison(skillsData, editingSkillsData)}
        message={messages.CONFIRM_DISCARD_FORM_CHANGES_ON_PAGE_LEAVE}
      />
      <ProfileTableItem
        anotherUser={anotherUser}
        title="Skills"
        description="Tell us about your amazing expertise, professional and personal skills"
        linkText="+ Add your skills"
        hasData={skillsData.length > 0}
        isActive={editing}
        onClick={() => {
          isEditing(true)
        }}
      />
      {!editing && skillsData && (
        <div className={styles.skillsTextWrap}>
          <p
            ref={skillsRef}
            className={classNames("text16r", styles.skills, {
              [styles.clamped]: !isExpanded,
            })}
          >
            {skillsData.map((skill) => (
              <span key={skill.id}>
                {skill !== skillsData[skillsData.length - 1]
                  ? `${skill.name},`
                  : skill.name}
              </span>
            ))}
          </p>
          {skillsData.length > 0 && (isClamped || isExpanded) ? (
            <button
              type="button"
              className={styles.toggleButton}
              onClick={() => setIsExpanded((prev) => !prev)}
            >
              {isExpanded ? "Show less" : "Show more"}
            </button>
          ) : null}
        </div>
      )}
      {editing && (
        <div className={styles.editSkillsWrap}>
          <TagEditor
            data={editingSkillsData}
            setData={setEditingSkillsData}
            className={styles.editor}
          />
          <div className={styles.btnsWrap}>
            <Button
              buttonStyle="outlined"
              className={styles.btn}
              onClick={
                editingSkillsData !== skillsData
                  ? () => isPopupVisible(true)
                  : () => isEditing(false)
              }
            >
              Cancel
            </Button>
            <Button
              buttonStyle="contained"
              className={styles.btn}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Skills
